<template>
  <div class="sub-title">
    <div class="sub-title-line" :style="{background: color}"></div>
    <div class="sub-title__text">
      <div class="sub-title__title">{{ title }}
        <span>{{ label }}</span></div>
      <div class="sub-title__description">{{ description }}</div>
    </div>
  </div>
</template>


<script>
export default {
  props: ["color", "title", "description", "label"]
};
</script>


<style lang="scss" scoped>
.sub-title {
  display: flex;
  grid-gap: 10px;
  margin-left: 5px;
}

.sub-title-line {
  height: auto;
  width: 6px;
  background-color: rgb(203, 191, 166);
  border-radius: 3px;
}

.sub-title__text {

}

.sub-title__title {
  font-weight: 600;
  font-size: 16px;
  display: flex;
  grid-gap: 10px;
  align-items: flex-end;

  span {
    font-weight: 400;
    font-size: 12.5px;
    color: rgb(138, 130, 118);
  }
}

.sub-title__description {
  font-size: 12.5px;
  color: rgb(90, 82, 73);
  margin-top: 2px;
  font-weight: 400;

}
</style>